import { render, staticRenderFns } from "./EditModel3d.vue?vue&type=template&id=2fbd7ccc&scoped=true"
import script from "./EditModel3d.ts?vue&type=script&lang=ts&external"
export * from "./EditModel3d.ts?vue&type=script&lang=ts&external"
import style0 from "./EditModel3d.vue?vue&type=style&index=0&id=2fbd7ccc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbd7ccc",
  null
  
)

export default component.exports